const genericErrorMessage = `We are sorry, there was an error setting up your payment method. Please try again or choose a different payment method.`;

class SetupIntentConfirmationError extends Error {
  stripeError: stripe.Error;

  constructor(stripeError: stripe.Error) {
    super(stripeError.message ?? genericErrorMessage);
    this.stripeError = stripeError;
  }
}

export { SetupIntentConfirmationError };
